<template>
<div>
  <div class="horizontal">
    <div class="left">{{ item.heading }}</div>
    <div class="right">{{ $planConfig.experienceStatusList[item.data.experienceStatus] }}
      <template v-if="item.data.experienceStatus !== 'inexperience'">
        <br>[事業内容]
        <br>{{ item.data.businessContents }}
      </template>
      <template v-if="item.data.experienceStatus === 'quit'">
        <br>[やめた時期]
        <br>{{ $planConfig.dateIntFormat(item.data.stopDate) }}
      </template>
    </div>
  </div>
  <expert-comment v-bind:item="item"
    v-if="isConsultationPlan"
    v-bind:groupIndex="groupIndex"
    v-bind:itemIndex="itemIndex"
    v-bind:isEditableComment="isEditableComment"></expert-comment>
</div>
</template>

<script>
import expertComment from '@/components/parts/ExpertComment'
export default {
  components: {
    'expert-comment': expertComment
  },
  data() {
    return {}
  },
  props: ['item', 'groupIndex', 'itemIndex', 'isConsultationPlan', 'isEditableComment'],
  computed: {},
  mounted: function () {},
  methods: {}
}
</script>
